import type { RouteRecordRaw } from 'vue-router';

// A-S1 admin audit log per ADR-007 §Per-endpoint role table — admin only.
export const routes: RouteRecordRaw[] = [
  {
    path: '/auctions/:id/audit',
    name: 'audit-log',
    component: () => import('./pages/AuditLogPage.vue'),
    meta: { requiresAdminAuth: true, requiredRole: 'admin' },
  },
];
